export enum PeriodBoundary {
  START = 'start',
  END = 'end'
}
